/* eslint-disable react-hooks/exhaustive-deps */
import { NavBar } from "../../../common/NavBar";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SiteCamerasTable } from "./SiteCameras";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { TabsComponet } from "./TabsComponet";
import { CancelButton } from "./CancelButton";
import { SaveChangesButton } from "./SaveChangesButton";
import { EditInformationButton } from "./EditInformationButton";
import { BreadCrumbsComponet } from "../../../common/BreadCrumbsComponent";
import BackdropLoadingScreen from "../../../common/BackdropLoadingScreen";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import { SyncSiteButton } from "./SyncSiteButton";
import { createLinksArray } from "./SiteAboutPageUtils/createLinksArray";
import FormControlLabel from "@mui/material/FormControlLabel";
import { SiteAboutDialogs } from "./SiteAboutDialogs";
import { AddSiteWebhookDialog } from "./AddSiteWebhookDialog";
import { WebhooksTab } from "./WebhooksTab";
import {
  WebhooksPatchMap,
  mergeWebhookById,
} from "./SiteAboutPageUtils/siteWebhooks";
import { SiteAboutAlerts } from "./SiteAboutAlerts";
import useWindowDimensions from "../../../common/useWindowDimensions";
import Tooltip from "@mui/material/Tooltip";
import {
  AlertState,
  IgnoreZone,
  SiteCameras,
  SiteSchedule,
  PatchObject,
  Dispatcher,
  WireGuardTunnel,
} from "./SiteAboutPageUtils/siteAboutInterfaces";
import { IDLE_CONFIGURE_MOTION } from "./SiteAboutPageUtils/configureMotionStatus";
import { fetchWireguardTunnelsForCustomer } from "./SiteAboutPageUtils/fetchWireguardTunnels";
import {
  WireGuardTabEditMode,
  WireGuardEditSession,
} from "./WireGuardTabEditMode";
import { WireGuardTab } from "./WireGuardTab";
import { handleGetAllData } from "./SiteAboutPageUtils/handleGetAllData";
import { Alert } from "@mui/material";
import ErrorBoundary from "../../../../ErrorBoundary";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import {
  getSiteIdFromUrl,
  markSiteSynced,
  markSiteUnsynced,
  useCurrentSiteSyncNeeded,
  useSyncStore,
} from "../../../utils/syncStore";
import { GreenRedSwitch } from "../../../common/GreenRedSwitch";
import { ArmedStatusChip } from "./ArmedStatusChip";
import { getArmedStatusPresentation } from "../SitesPage/SitesPageUtils/armedStatusPresentation";
import { cancelIconRed } from "../../../common/cancelIconRed";
import { checkedCircleIcon } from "../../../common/checkedCircleIcon";
import AutoPatrolScheduleDropDown from "./AutoPatrolScheduleDropDown";
import { SchedulesTab } from "./SchedulesTab";
import { SiteAboutAutoPatrol } from "./SiteAboutAutoPatrol";
import { SiteAboutActionsMenu } from "./SiteAboutActionsMenu";
import { ActionLogsText } from "./SiteAboutPageUtils/actionLogsText";
import { getNumbersAfterAboutSite } from "./SiteAboutPageUtils/getNumbersAfterAboutSite";
import { createApi } from "../../../utils/createApi";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { useFlexIgnoreZonesOnboardingStore } from "./FlexIgnoreZonesOnboarding/flexIgnoreZonesOnboardingStore";
import {
  FlexCameraSummary,
  FlexScheduleSummary,
} from "./FlexIgnoreZonesOnboarding/types";
import { shouldOfferRebootToApply } from "../../../utils/shouldOfferRebootToApply";
import { useIsStaffUser } from "../../../utils/staffUser";
import { DoubleTakeSaveResult, DoubleTakeTab } from "./DoubleTakeTab";
import {
  DOUBLE_TAKE_TAB,
  canToggleDoubleTake,
  shouldShowDoubleTakeTab,
} from "./SiteAboutPageUtils/siteDoubleTake";

export { ActionLogsText, getNumbersAfterAboutSite };

export const SiteAbout = ({
  permissions,
  navBarCollapsed,
  setNavBarCollapsed,
}: {
  permissions: any;
  navBarCollapsed: boolean;
  setNavBarCollapsed: Dispatcher<boolean>;
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const siteIdFromUrl = React.useMemo(
    () => getNumbersAfterAboutSite(pathname),
    [pathname]
  );
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [initialFlexPresetSyncComplete, setInitialFlexPresetSyncComplete] =
    React.useState(false);
  const [loadProgressPercent, setLoadProgressPercent] = React.useState(5);
  const [loadProgressMessage, setLoadProgressMessage] = React.useState(
    "Loading site data..."
  );
  const [clickedTab, setClickedTab] = React.useState("one");
  const [editMode, setEditMode] = React.useState(false);
  const [siteInfo, setSiteInfo] = React.useState<any>({});
  const [siteInfoBackup, setSiteInfoBackup] = React.useState<any>({});
  const [webhooksInfo, setWebhooksInfo] = React.useState<any>([]);
  const [activeTab, setActiveTab] = React.useState(<></>);
  const [vmsVariables, setVmsVariables] = React.useState<
    (string | string[] | undefined)[][]
  >([]);
  const [vmsVariablesBackup, setVmsVariablesBackup] = React.useState<
    (string | string[] | undefined)[][]
  >([]);
  const [patchObject, setPatchObject] = React.useState<PatchObject>({
    name: "",
  });
  const [schedulesTabActive, setSchedulesTabActive] = React.useState(false);
  const [siteSchedules, setSiteSchedules] = React.useState<SiteSchedule[]>([]);
  const [allSiteSchedules, setAllSiteSchedules] = React.useState<
    SiteSchedule[]
  >([]);
  // Pending Webhooks-tab edits, keyed by webhook id (ENG-2233).
  const [webhooksPatchObject, setWebhooksPatchObject] =
    React.useState<WebhooksPatchMap>({});
  const [webhooksChangesMade, setWebhooksChangesMade] = React.useState(false);
  // Leaving edit mode (Save or Cancel) drops any pending webhook edits so a
  // later Save on another tab can't replay them.
  React.useEffect(() => {
    if (!editMode) {
      setWebhooksPatchObject({});
      setWebhooksChangesMade(false);
    }
  }, [editMode]);
  const [wireguardTunnels, setWireguardTunnels] = React.useState<
    WireGuardTunnel[]
  >([]);
  const [wireguardTunnelsLoading, setWireguardTunnelsLoading] =
    React.useState(false);
  const [selectedWireguardTunnelId, setSelectedWireguardTunnelId] =
    React.useState<number | null>(null);
  const [wireguardChangesMade, setWireguardChangesMade] = React.useState(false);
  const wireGuardEditSessionRef = React.useRef<WireGuardEditSession | null>(
    null
  );

  const { width } = useWindowDimensions();

  const [alertState, setAlertState] = React.useState<AlertState>({
    changeSuccess: false,
    noCameraOrSchedule: false,
    noSchedule: false,
    activateSuccess: false,
    deactivateSuccess: false,
    disarmSuccess: false,
    armSuccess: false,
    armFail: false,
    syncSuccess: false,
    cameraDeleteSuccess: false,
    configureMotion: IDLE_CONFIGURE_MOTION,
    refreshCameraSuccess: false,
    refreshCameraFail: false,
    webhookChangesFail: false,
  });
  const [camerasNotDeployed, setCamerasNotDeployed] = React.useState(false);
  const [backdropLoadingScreenOn, setBackdropLoadingScreenOn] =
    React.useState(true);
  // Sync state lives in the shared per-site sync store — the same source the
  // edit-view Sync controls subscribe to, so site-level and camera-level
  // indicators can never disagree, and another site's pending changes never
  // show here. The setter adapter keeps the React.Dispatch signature the
  // downstream utils (handleGetAllData, handleSyncSite, dialogs, …) expect.
  const syncNeeded = useCurrentSiteSyncNeeded();
  const setSyncNeeded: React.Dispatch<React.SetStateAction<boolean>> =
    React.useCallback((value) => {
      const siteId = getSiteIdFromUrl();
      const next =
        typeof value === "function"
          ? value(useSyncStore.getState().unsyncedSiteIds.includes(siteId))
          : value;
      if (next) {
        markSiteUnsynced(siteId);
      } else {
        markSiteSynced(siteId);
      }
    }, []);
  const [deleteSiteDialogOpen, setDeleteSiteDialogOpen] = React.useState(false);
  const [deleteScheduleDialogOpen, setDeleteScheduleDialogOpen] =
    React.useState(false);
  const [siteInfoChangesMade, setSiteInfoChangesMade] = React.useState(false);
  const [scheduleChangesMade, setScheduleChangesMade] = React.useState(false);
  const [siteCameras, setSiteCameras] = React.useState<SiteCameras>(
    localStorage.siteCameras ? JSON.parse(localStorage.siteCameras) : []
  );
  const [disarmDialogOpen, setDisarmDialogOpen] = React.useState(false);
  const [armDialogOpen, setArmDialogOpen] = React.useState(false);
  const [rebootDialogOpen, setRebootDialogOpen] = React.useState(false);
  const [activateSiteDialogOpen, setActivateSiteDialogOpen] =
    React.useState(false);
  const [deactivateSiteDialogOpen, setDeactivateSiteDialogOpen] =
    React.useState(false);
  const [deativateInquiryDialogOpen, setDeativateInquiryDialogOpen] =
    React.useState(false);
  const [noAutoAddCamerasDialogOpen, setNoAutoAddCamerasDialogOpen] =
    React.useState(false);

  const [siteDeployed, setSiteDeployed] = React.useState(true);

  const [aiLinkSite, setAiLinkSite] = React.useState(false);

  const [toolTipTitle, setToolTipTitle] = React.useState("");

  const [configureMotion, setConfigureMotion] = React.useState(false);

  const ref = React.useRef<HTMLDivElement>(null);
  const isMountedRef = React.useRef(true);

  const [armedStatus, setArmedStatus] = React.useState(false);

  const [armButtonDisabled, setArmButtonDisabled] = React.useState(false);

  const [recordingServerData, setRecordingServerData] = React.useState({});

  const [recordingServerPatchObject, setRecordingServerPatchObject] =
    React.useState({});

  const [recordingServerChangesMade, setRecordingServerChangesMade] =
    React.useState(false);

  const [recordingServerVisible, setRecordingServerVisible] =
    React.useState(false);

  const [healthCheckData, setHealthCheckData] = React.useState({});

  const [cameraHealthPatchObject, setCameraHealthPatchObject] = React.useState(
    {}
  );

  const [cameraHealthChangesMade, setCameraHealthChangesMade] =
    React.useState(false);

  const [camerasRefreshing, setCamerasRefreshing] = React.useState(false);

  const [addCameraHealthDialogOpen, setAddCameraHealthDialogOpen] =
    React.useState(false);

  const [turnOffHealthDialogOpen, setTurnOffHealthDialogOpen] =
    React.useState(false);

  const [cameraCheckAlertOpen, setCameraCheckAlertOpen] = React.useState(
    localStorage.cameraCheckAlertOpen === "true"
  );

  const [deactivateSiteInsteadDialogOpen, setDeactivateSiteInsteadDialogOpen] =
    React.useState(false);

  const [
    activateSiteWithScheduleDialogOpen,
    setActivateSiteWithScheduleDialogOpen,
  ] = React.useState(false);

  const [siteSchedulesBackup, setSiteSchedulesBackup] = React.useState<any>([]);

  const [flexScheduleOnEditButtonClick, setFlexScheduleOnEditButtonClick] =
    React.useState(false);

  const [armSiteFlexScheduleDialogOpen, setArmSiteFlexScheduleDialogOpen] =
    React.useState(false);

  // Which flavor the flex schedule picker should send: "arm" from the Arm
  // toggle, "reboot" when reached from a reboot-to-apply flow (RebootDialog
  // handoff) so the action log reads "Manual Reboot" (ENG-1404 / SUP-433).
  const [armSiteFlexScheduleDialogAction, setArmSiteFlexScheduleDialogAction] =
    React.useState<"arm" | "reboot">("arm");

  const [
    disarmSiteFlexScheduleDialogOpen,
    setDisarmSiteFlexScheduleDialogOpen,
  ] = React.useState(false);

  const {
    resetSiteAboutState,
    getHealthCheckMetricsData,
    prefetchSiteMetricsSimplified,
    backdropLoadingScreenOnEditingSchedule,
    vCHOnlySchedules,
    autoPatrolSchedules,
  } = useSiteAboutStore();
  const syncFlexIgnoreZonesEnabledFromApi = useFlexIgnoreZonesOnboardingStore(
    (state) => state.syncFlexIgnoreZonesEnabledFromApi
  );
  const resetFlexIgnoreZonesOnboardingState = useFlexIgnoreZonesOnboardingStore(
    (state) => state.resetAll
  );
  const { isFeatureEnabled } = useFeatureFlag();
  const showFlexIgnoreZonesFlag = isFeatureEnabled(
    "showFlexIgnoreZones",
    false
  );
  const showWireguard = isFeatureEnabled("showWireguard", false);
  const showWireguardTab =
    showWireguard && Boolean(siteInfo?.display_wireguard);
  const isStaff = useIsStaffUser();
  // A customer without group access who turns DoubleTake off would otherwise
  // lose the tab they're standing on; keep it until they leave the site.
  const [keepDoubleTakeTab, setKeepDoubleTakeTab] = React.useState(false);
  React.useEffect(() => setKeepDoubleTakeTab(false), [siteIdFromUrl]);
  const showDoubleTakeTab =
    (keepDoubleTakeTab && isFeatureEnabled("showVlmFilters", false)) ||
    shouldShowDoubleTakeTab(
      isFeatureEnabled("showVlmFilters", false),
      siteInfo,
      isStaff
    );
  const doubleTakeTabOpen = clickedTab === DOUBLE_TAKE_TAB && showDoubleTakeTab;
  // Edit Information only shows on the DoubleTake tab when there's something
  // this user may change there (ENG-2611).
  const doubleTakeEditable = canToggleDoubleTake(
    Boolean(siteInfo?.vlm_enabled),
    siteInfo,
    isStaff
  );
  const doubleTakeSaveRef = React.useRef<
    (() => Promise<DoubleTakeSaveResult>) | null
  >(null);
  const handleSaveDoubleTake = async () => {
    setBackdropLoadingScreenOn(true);
    const result = (await doubleTakeSaveRef.current?.()) ?? "unchanged";
    setBackdropLoadingScreenOn(false);
    if (result === "failed") {
      return;
    }
    if (result === "saved") {
      setAlertState((previousState: AlertState) => ({
        ...previousState,
        changeSuccess: true,
        activateSuccess: false,
        deactivateSuccess: false,
        disarmSuccess: false,
        armSuccess: false,
        syncSuccess: false,
        cameraDeleteSuccess: false,
      }));
      setSyncNeeded(true);
    }
    setEditMode(false);
  };

  const onWireGuardSessionUpdate = React.useCallback(
    (session: WireGuardEditSession) => {
      wireGuardEditSessionRef.current = session;
    },
    []
  );

  const clearWireGuardEditSession = React.useCallback(() => {
    wireGuardEditSessionRef.current = null;
  }, []);

  const clearSiteAboutTransientState = React.useCallback(() => {
    [
      "siteCameraSelectionsBySiteId",
      "siteCamerasTablePagePreferences",
      "storedExpandedObject",
      "expandedObjectSaved",
      "siteAboutScrollTop",
      "siteCameras",
      "allSiteSchedulesBackup",
      "siteSchedule",
      "backUpSiteSchedule",
      "backUpStandardSchedule",
      "backUpFlexSchedule",
      "schedulesIndex",
      "clickedSchedulesTab",
      "cameraCheckAlertOpen",
      "groupNameChange",
      "flexSchedulingChanged",
      "flexSchedulesOn",
      "scheduleChangeError",
      "scheduleSubmitError",
      "backupHealthCheckMetrics",
      "backupAutoPatrolSchedules",
      "backupAutoPatrolScheduleHealthchckMetrics",
      "backupCameraProductsByScheduleId",
      "backupProductMetricsIdsByScheduleId",
      "armButtonCheckURL",
      // Do not clear navigatedFromSitesAboutPage — destination pages (auto-add,
      // add camera, etc.) use it to return here instead of the Sites list.
    ].forEach((key) => localStorage.removeItem(key));
  }, []);

  const handleSiteLoadPhase = React.useCallback(
    (
      phase:
        | "site-metadata"
        | "site-extra-fields"
        | "site-cameras"
        | "site-schedules-and-health"
        | "camera-row-prefetch-start"
        | "camera-row-prefetch-progress"
        | "camera-row-prefetch-complete",
      progress?: { completed: number; total: number }
    ) => {
      if (phase === "site-metadata") {
        setLoadProgressPercent(25);
        setLoadProgressMessage("Loading site fields...");
        return;
      }
      if (phase === "site-extra-fields") {
        setLoadProgressPercent(45);
        setLoadProgressMessage("Loading cameras...");
        return;
      }
      if (phase === "site-cameras") {
        setLoadProgressPercent(70);
        setLoadProgressMessage("Loading camera details...");
        return;
      }
      if (phase === "camera-row-prefetch-start") {
        const total = progress?.total ?? 0;
        setLoadProgressPercent(74);
        setLoadProgressMessage(
          total > 0
            ? `Loading camera details (0/${total})...`
            : "Loading camera details..."
        );
        return;
      }
      if (phase === "camera-row-prefetch-progress") {
        const completed = progress?.completed ?? 0;
        const total = progress?.total ?? 0;
        const ratio = total > 0 ? completed / total : 1;
        const clampedRatio = Math.max(0, Math.min(1, ratio));
        const percent = 74 + Math.round(clampedRatio * 8);
        setLoadProgressPercent(percent);
        setLoadProgressMessage(
          total > 0
            ? `Loading camera details (${completed}/${total})...`
            : "Saving camera details..."
        );
        return;
      }
      if (phase === "camera-row-prefetch-complete") {
        setLoadProgressPercent(82);
        setLoadProgressMessage("Loaded per-camera details...");
        return;
      }
      setLoadProgressPercent(85);
      setLoadProgressMessage("Loaded schedules and health data...");
    },
    []
  );

  const siteCameraIdsKey = React.useMemo(() => {
    const results = siteCameras?.results;
    if (!Array.isArray(results)) {
      return "";
    }
    return results
      .map((camera: { id: number }) => Number(camera.id))
      .filter((id) => Number.isFinite(id))
      .sort((a, b) => a - b)
      .join(",");
  }, [siteCameras]);

  const flexSchedulesForSync = React.useMemo((): FlexScheduleSummary[] => {
    if (!Array.isArray(siteSchedules) || siteSchedules.length === 0) {
      return [];
    }
    return siteSchedules.map((s, idx) => {
      const row = s as unknown as {
        id?: string | number;
        display_name?: string;
      };
      return {
        id: Number(row.id ?? idx + 1),
        display_name: row.display_name || `Schedule ${idx + 1}`,
      };
    });
  }, [siteSchedules]);

  const siteScheduleIdsKey = React.useMemo(
    () => flexSchedulesForSync.map((s) => s.id).join(","),
    [flexSchedulesForSync]
  );

  React.useEffect(() => {
    isMountedRef.current = true;
    setInitialFlexPresetSyncComplete(false);
    setLoadProgressPercent(5);
    setLoadProgressMessage("Loading site data...");
    clearSiteAboutTransientState();
    resetSiteAboutState();
    resetFlexIgnoreZonesOnboardingState();
    handleGetAllData(
      siteIdFromUrl,
      navigate,
      setSiteInfo,
      setSiteSchedules,
      setSiteCameras,
      setActiveTab,
      setDataLoaded,
      setBackdropLoadingScreenOn,
      setAllSiteSchedules,
      setVmsVariables,
      setNoAutoAddCamerasDialogOpen,
      setArmedStatus,
      setAiLinkSite,
      setSiteDeployed,
      setSyncNeeded,
      setAlertState,
      setCamerasNotDeployed,
      setToolTipTitle,
      setConfigureMotion,
      setPatchObject,
      setArmButtonDisabled,
      setRecordingServerData,
      setRecordingServerPatchObject,
      setRecordingServerVisible,
      setHealthCheckData,
      setWebhooksInfo,
      setWebhooksPatchObject,
      () => isMountedRef.current,
      handleSiteLoadPhase
    );
    getHealthCheckMetricsData(navigate, siteIdFromUrl);
    prefetchSiteMetricsSimplified?.(navigate, siteIdFromUrl);
    localStorage.setItem("schedulesIndex", "0");
    localStorage.setItem("clickedSchedulesTab", "one");
    let cameraCheckTimerId: ReturnType<typeof setTimeout> | undefined;
    if (localStorage.cameraCheckAlertOpen === "true") {
      cameraCheckTimerId = setTimeout(() => {
        if (isMountedRef.current) {
          setCameraCheckAlertOpen(false);
          localStorage.setItem("cameraCheckAlertOpen", "false");
        }
      }, 10000);
    }
    return () => {
      isMountedRef.current = false;
      if (cameraCheckTimerId !== undefined) clearTimeout(cameraCheckTimerId);
      resetSiteAboutState();
      resetFlexIgnoreZonesOnboardingState();
      clearSiteAboutTransientState();
    };
  }, [
    clearSiteAboutTransientState,
    handleSiteLoadPhase,
    navigate,
    prefetchSiteMetricsSimplified,
    resetFlexIgnoreZonesOnboardingState,
    resetSiteAboutState,
    getHealthCheckMetricsData,
    siteIdFromUrl,
  ]);

  // Reconnect the reboot prompt. The settings-editing flows (edit camera,
  // ignore zones, metadata tags, line crossings) sync changes to the cloud
  // and set a one-shot `rebootSite` flag, but nothing ever consumed it, so
  // the customer was never asked whether to reboot to apply their changes.
  // When the operator lands back on the About page with pending changes,
  // surface the existing RebootDialog so they choose whether to reboot now —
  // but only if the site is currently armed. If it's disarmed, the changes
  // are picked up automatically the next time it arms, so no prompt is needed.
  React.useEffect(() => {
    if (!dataLoaded || !siteInfo?.id) return;
    if (localStorage.getItem("rebootSite") !== "true") return;
    // Consume the one-shot flag so it can't re-trigger on a later load.
    localStorage.setItem("rebootSite", "false");
    // Reboot = arm. Only offer it when the site is also MEANT to be armed
    // now — schedule or manual arm (ENG-811 — `armed` alone lags a stop).
    if (shouldOfferRebootToApply(siteInfo)) {
      setRebootDialogOpen(true);
    }
  }, [dataLoaded, siteInfo?.id, siteInfo?.armed, siteInfo?.arm_intended]);

  React.useEffect(() => {
    const handleRefreshSiteCamerasTable = () => {
      const AxiosUI = createApi("");
      AxiosUI.get(`camera/site/?customer__id=${siteIdFromUrl}`).then(
        (response) => {
          localStorage.setItem("siteCameras", JSON.stringify(response.data));
          setSiteCameras(response.data);
        }
      );
    };

    window.addEventListener(
      "refreshSiteCamerasTable",
      handleRefreshSiteCamerasTable
    );
    return () => {
      window.removeEventListener(
        "refreshSiteCamerasTable",
        handleRefreshSiteCamerasTable
      );
    };
  }, [siteIdFromUrl]);

  React.useEffect(() => {
    if (!showWireguard || !siteInfo?.display_wireguard || !siteIdFromUrl) {
      return;
    }
    let cancelled = false;
    (async () => {
      setWireguardTunnelsLoading(true);
      try {
        const list = await fetchWireguardTunnelsForCustomer(siteIdFromUrl);
        if (!cancelled) {
          setWireguardTunnels(list);
        }
      } catch {
        if (!cancelled) {
          setWireguardTunnels([]);
        }
      } finally {
        if (!cancelled) {
          setWireguardTunnelsLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [showWireguard, siteInfo?.display_wireguard, siteIdFromUrl]);

  React.useEffect(() => {
    if (wireguardTunnels.length === 0) {
      setSelectedWireguardTunnelId(null);
      return;
    }
    setSelectedWireguardTunnelId((prev) => {
      if (prev != null && wireguardTunnels.some((t) => t.id === prev)) {
        return prev;
      }
      return wireguardTunnels[0].id;
    });
  }, [wireguardTunnels]);

  const setScrollTop = (event: any) => {
    localStorage.setItem("siteAboutScrollTop", event.target.scrollTop);
  };

  React.useEffect(() => {
    if (ref) {
      setTimeout(() => {
        if (ref.current !== null) {
          ref.current.scrollTop = localStorage.siteAboutScrollTop;
        }
      }, 500);
    }
  }, [backdropLoadingScreenOn]);

  React.useEffect(() => {
    localStorage.setItem("navigatedFromSitesAboutPage", "true");
    localStorage.setItem(
      "allSiteSchedulesBackup",
      JSON.stringify(siteSchedules)
    );
  }, []);

  // Set Schedules tab as default for autopatrol sites (vCH-only path)
  React.useEffect(() => {
    if (siteInfo?.integration_type_name === "autopatrol") {
      setClickedTab("three");
      setSchedulesTabActive(true);
      setActiveTab(<SchedulesTab siteInfo={siteInfo} />);
    }
  }, [siteInfo?.integration_type_name]);

  React.useEffect(() => {
    if (!dataLoaded) {
      setInitialFlexPresetSyncComplete(false);
      return;
    }
    if (
      !siteInfo?.id ||
      !siteInfo?.has_flex_schedule ||
      !showFlexIgnoreZonesFlag
    ) {
      setInitialFlexPresetSyncComplete(true);
      setLoadProgressPercent(100);
      setLoadProgressMessage("Finalizing...");
      return;
    }
    const results = siteCameras?.results;
    if (!Array.isArray(results)) {
      return;
    }
    const flexCameras: FlexCameraSummary[] = results.map(
      (camera: {
        id: number;
        camera_name: string;
        preview_url?: string;
        ignore_zones?: IgnoreZone[];
      }) => ({
        id: Number(camera.id),
        camera_name: camera.camera_name,
        preview_url: camera.preview_url,
        ignore_zones: camera.ignore_zones,
      })
    );
    let cancelled = false;
    const shouldCompleteInitialLoad = !initialFlexPresetSyncComplete;
    if (shouldCompleteInitialLoad) {
      setLoadProgressPercent(90);
      setLoadProgressMessage("Loading flex schedule presets...");
    }
    void (async () => {
      try {
        await syncFlexIgnoreZonesEnabledFromApi(
          Number(siteInfo.id),
          flexCameras,
          flexSchedulesForSync.length > 0 ? flexSchedulesForSync : undefined,
          showFlexIgnoreZonesFlag
        );
      } finally {
        if (!cancelled && shouldCompleteInitialLoad) {
          setLoadProgressPercent(100);
          setLoadProgressMessage("Finalizing...");
          setInitialFlexPresetSyncComplete(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    dataLoaded,
    siteInfo?.id,
    siteInfo?.has_flex_schedule,
    siteCameraIdsKey,
    siteScheduleIdsKey,
    flexSchedulesForSync,
    initialFlexPresetSyncComplete,
    syncFlexIgnoreZonesEnabledFromApi,
    showFlexIgnoreZonesFlag,
  ]);

  const waitForFlexPresetHydration =
    dataLoaded &&
    showFlexIgnoreZonesFlag &&
    Boolean(siteInfo?.has_flex_schedule) &&
    !initialFlexPresetSyncComplete;

  //on Unmount
  // React.useEffect(
  //   () => () => {
  //   },
  //   []
  // )

  const handleSiteBreadcrumbClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    localStorage.setItem("siteAboutScrollTop", "0");
    localStorage.setItem("expandedObjectSaved", "false");
    localStorage.setItem("navigatedFromSitesAboutPage", "true");
    localStorage.setItem("level0Click", "true");
    localStorage.setItem("sitesTablePage", "0");

    localStorage.setItem(
      "storedSelectedIndex",
      JSON.stringify({
        level1: [],
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: [],
      })
    );
    siteInfo?.integration_type_name === "autopatrol"
      ? navigate("/sites_patrol")
      : navigate("/sites");
  };

  // const {
  //   getSiteInfo,
  //   loadAllData
  // } = useSiteAboutStore();

  //  React.useEffect(() => {
  //    getSiteInfo(() => { getSiteInfo }, navigate);
  //   }, []);

  // Conditionally render SiteAboutAutoPatrol only when autopatrol has at least one AutoPatrol schedule; vCH-only uses main layout below
  if (siteInfo?.integration_type_name === "autopatrol" && !vCHOnlySchedules) {
    return (
      <SiteAboutAutoPatrol
        permissions={permissions}
        navBarCollapsed={navBarCollapsed}
        setNavBarCollapsed={setNavBarCollapsed}
      />
    );
  }

  return (
    <div>
      <div>
        {cameraCheckAlertOpen && (
          <Alert
            severity="info"
            onClose={() => {
              setCameraCheckAlertOpen(false);
              localStorage.setItem("cameraCheckAlertOpen", "false");
            }}
          >
            Camera check is running in the background. This may take a few
            minutes. You will be alerted when it is complete. Please do not
            close your window or refresh any page until the check has been
            completed.
          </Alert>
        )}
        <AddSiteWebhookDialog
          siteId={Number(getNumbersAfterAboutSite(location.href))}
          navigate={navigate}
          onCreated={(webhook) => {
            const nextWebhooks = mergeWebhookById(webhooksInfo, webhook);
            setWebhooksInfo(nextWebhooks);
            useSiteAboutStore.getState().setBackupWebhookData(nextWebhooks);
            if (clickedTab === "seven" && !editMode) {
              setActiveTab(<WebhooksTab webhooksInfo={nextWebhooks} />);
            }
            setAlertState((previousState: AlertState) => ({
              ...previousState,
              changeSuccess: true,
            }));
          }}
        />
        <SiteAboutDialogs
          setDeleteScheduleDialogOpen={setDeleteScheduleDialogOpen}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setAllSiteSchedules={setAllSiteSchedules}
          setSiteInfo={setSiteInfo}
          editMode={editMode}
          setActiveTab={setActiveTab}
          siteInfo={siteInfo}
          setScheduleChangesMade={setScheduleChangesMade}
          rebootDialogOpen={rebootDialogOpen}
          setRebootDialogOpen={setRebootDialogOpen}
          setAlertState={setAlertState}
          activateSiteDialogOpen={activateSiteDialogOpen}
          setActivateSiteDialogOpen={setActivateSiteDialogOpen}
          setPatchObject={setPatchObject}
          patchObject={patchObject}
          deactivateSiteDialogOpen={deactivateSiteDialogOpen}
          setDeactivateSiteDialogOpen={setDeactivateSiteDialogOpen}
          deativateInquiryDialogOpen={deativateInquiryDialogOpen}
          setDeativateInquiryDialogOpen={setDeativateInquiryDialogOpen}
          disarmDialogOpen={disarmDialogOpen}
          setDisarmDialogOpen={setDisarmDialogOpen}
          armDialogOpen={armDialogOpen}
          setArmDialogOpen={setArmDialogOpen}
          deleteSiteDialogOpen={deleteSiteDialogOpen}
          setDeleteSiteDialogOpen={setDeleteSiteDialogOpen}
          navigate={navigate}
          setSyncNeeded={setSyncNeeded}
          noAutoAddCamerasDialogOpen={noAutoAddCamerasDialogOpen}
          setNoAutoAddCamerasDialogOpen={setNoAutoAddCamerasDialogOpen}
          setArmedStatus={setArmedStatus}
          setArmButtonDisabled={setArmButtonDisabled}
          setEditMode={setEditMode}
          clickedTab={clickedTab}
          vmsVariables={vmsVariables}
          siteSchedules={siteSchedules}
          setSiteSchedules={setSiteSchedules}
          addCameraHealthDialogOpen={addCameraHealthDialogOpen}
          setAddCameraHealthDialogOpen={setAddCameraHealthDialogOpen}
          healthCheckData={healthCheckData}
          setCameraHealthPatchObject={setCameraHealthPatchObject}
          setCameraHealthChangesMade={setCameraHealthChangesMade}
          setHealthCheckData={setHealthCheckData}
          turnOffHealthDialogOpen={turnOffHealthDialogOpen}
          setTurnOffHealthDialogOpen={setTurnOffHealthDialogOpen}
          permissions={permissions}
          activateSiteWithScheduleDialogOpen={
            activateSiteWithScheduleDialogOpen
          }
          setActivateSiteWithScheduleDialogOpen={
            setActivateSiteWithScheduleDialogOpen
          }
          armSiteFlexScheduleDialogOpen={armSiteFlexScheduleDialogOpen}
          setArmSiteFlexScheduleDialogOpen={setArmSiteFlexScheduleDialogOpen}
          armSiteFlexScheduleDialogAction={armSiteFlexScheduleDialogAction}
          setArmSiteFlexScheduleDialogAction={
            setArmSiteFlexScheduleDialogAction
          }
          disarmSiteFlexScheduleDialogOpen={disarmSiteFlexScheduleDialogOpen}
          setDisarmSiteFlexScheduleDialogOpen={
            setDisarmSiteFlexScheduleDialogOpen
          }
          setToolTipTitle={setToolTipTitle}
        />
        <SiteAboutAlerts
          siteDeployed={siteDeployed}
          aiLinkSite={aiLinkSite}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setSyncNeeded={setSyncNeeded}
          setAlertState={setAlertState}
          siteInfo={siteInfo}
          setSiteInfo={setSiteInfo}
          setAllSiteSchedules={setAllSiteSchedules}
          setActiveTab={setActiveTab}
          vmsVariables={vmsVariables}
          setSiteDeployed={setSiteDeployed}
          setDeativateInquiryDialogOpen={setDeativateInquiryDialogOpen}
          setSiteCameras={setSiteCameras}
          camerasNotDeployed={camerasNotDeployed}
          setCamerasNotDeployed={setCamerasNotDeployed}
          navigate={navigate}
          setVmsVariables={setVmsVariables}
          alertState={alertState}
          setEditMode={setEditMode}
          setClickedTab={setClickedTab}
          setArmButtonDisabled={setArmButtonDisabled}
          setArmedStatus={setArmedStatus}
          setRebootDialogOpen={setRebootDialogOpen}
        />
        <BackdropLoadingScreen
          openState={backdropLoadingScreenOn || waitForFlexPresetHydration}
          progressPercent={loadProgressPercent}
          message={loadProgressMessage}
        />
        <BackdropLoadingScreen
          openState={backdropLoadingScreenOnEditingSchedule}
        />
        {dataLoaded && !waitForFlexPresetHydration && (
          <div
            className={"bg-actuate-grey absolute w-full h-full overflow-scroll"}
            onScroll={setScrollTop}
            ref={ref}
          >
            <ErrorBoundary>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[15px] left-[150px] right-0 h-[59px] bg-white min-w-[1440px]"
                    : "absolute top-[15px] left-[75px] right-0 h-[59px] bg-white min-w-[1440px]"
                }
              >
                <div className="flex items-center justify-between h-full pl-[30px] pr-3 gap-4">
                  <div className="flex items-center min-w-0 flex-1 gap-2 overflow-x-auto whitespace-nowrap">
                    <BreadCrumbsComponet
                      linksArray={createLinksArray(siteInfo.breadcrumb_info)}
                      handleClick={handleSiteBreadcrumbClick}
                      styling=""
                      breadcrumb_info={siteInfo.breadcrumb_info}
                      siteInfo={siteInfo}
                    />
                    {siteInfo.integration_type_name === "autopatrol" &&
                      autoPatrolSchedules !== null &&
                      autoPatrolSchedules.length > 0 && (
                        <p className="text-actuate-blue font-mulish font-bold text-[16px] whitespace-nowrap shrink-0">
                          Selected Schedule:
                        </p>
                      )}
                    {siteInfo.integration_type_name === "autopatrol" && (
                      <div className="shrink-0">
                        <AutoPatrolScheduleDropDown />
                      </div>
                    )}
                  </div>

                  <div className="flex items-center gap-6 shrink-0">
                    {/* Activating/deactivating a site is a settings change
                        (edit_cameras), not arm/disarm (PROD-56). Others see
                        the state read-only. */}
                    {permissions.edit_cameras &&
                      siteInfo.integration_type_name !== "autopatrol" && (
                        <FormControlLabel
                          control={
                            <GreenRedSwitch
                              checked={siteInfo.active}
                              color="warning"
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setPatchObject(
                                    (previousState: PatchObject) => {
                                      return {
                                        ...previousState,
                                        active: true,
                                      };
                                    }
                                  );
                                  setActivateSiteDialogOpen(true);
                                } else {
                                  setPatchObject(
                                    (previousState: PatchObject) => {
                                      return {
                                        ...previousState,
                                        active: false,
                                      };
                                    }
                                  );
                                  setDeactivateSiteDialogOpen(true);
                                }
                              }}
                            />
                          }
                          label="Active"
                        />
                      )}
                    {(siteInfo.integration_type_name === "autopatrol" ||
                      !permissions.edit_cameras) && (
                      <div className="flex items-center">
                        <div className="text-[16px] font-mulish">Active</div>
                        <div className="ml-2">
                          {siteInfo.active ? checkedCircleIcon : cancelIconRed}
                        </div>
                      </div>
                    )}
                    {!aiLinkSite &&
                      permissions.arm_disarm &&
                      siteInfo.integration_type_name !== "autopatrol" && (
                        <div className="flex items-center">
                          <Tooltip
                            title={
                              getArmedStatusPresentation(
                                siteInfo.armed_status,
                                siteInfo.armed,
                                siteInfo.active
                              ).description
                            }
                            placement="top"
                            sx={{ fontSize: "15px", fontFamily: "mulish" }}
                          >
                            <FormControlLabel
                              control={
                                <GreenRedSwitch
                                  checked={armedStatus}
                                  disabled={
                                    armButtonDisabled || !siteInfo.active
                                  }
                                  onChange={(event) => {
                                    if (event.target.checked) {
                                      if (siteInfo.has_flex_schedule) {
                                        setArmSiteFlexScheduleDialogAction(
                                          "arm"
                                        );
                                        setArmSiteFlexScheduleDialogOpen(true);
                                      } else {
                                        setArmDialogOpen(true);
                                      }
                                    } else {
                                      if (siteInfo.has_flex_schedule) {
                                        setDisarmSiteFlexScheduleDialogOpen(
                                          true
                                        );
                                      } else {
                                        setDisarmDialogOpen(true);
                                      }
                                    }
                                  }}
                                />
                              }
                              label="Armed"
                            />
                          </Tooltip>
                          <ArmedStatusChip
                            armedStatus={siteInfo.armed_status}
                            armed={siteInfo.armed}
                            active={siteInfo.active}
                          />
                        </div>
                      )}
                    {siteInfo.integration_type_name === "autopatrol" && (
                      <div className="flex items-center">
                        <div className="text-[16px] font-mulish">Armed</div>
                        <div className="ml-2">
                          {armedStatus ? checkedCircleIcon : cancelIconRed}
                        </div>
                      </div>
                    )}
                    {permissions.edit_cameras &&
                      siteInfo.integration_type_name !== "autopatrol" &&
                      siteInfo.integration_type_name !== "clips" && (
                        <SyncSiteButton
                          syncNeeded={syncNeeded}
                          setBackdropLoadingScreenOn={
                            setBackdropLoadingScreenOn
                          }
                          setSyncNeeded={setSyncNeeded}
                          setAlertState={setAlertState}
                          siteInfo={siteInfo}
                          setSiteInfo={setSiteInfo}
                          setAllSiteSchedules={setAllSiteSchedules}
                          setActiveTab={setActiveTab}
                          vmsVariables={vmsVariables}
                          setSiteDeployed={setSiteDeployed}
                          setDeativateInquiryDialogOpen={
                            setDeativateInquiryDialogOpen
                          }
                          setSiteCameras={setSiteCameras}
                          camerasNotDeployed={camerasNotDeployed}
                          setCamerasNotDeployed={setCamerasNotDeployed}
                          navigate={navigate}
                          setVmsVariables={setVmsVariables}
                          setClickedTab={setClickedTab}
                          setArmButtonDisabled={setArmButtonDisabled}
                          setArmedStatus={setArmedStatus}
                          setRebootDialogOpen={setRebootDialogOpen}
                        />
                      )}
                    <SiteAboutActionsMenu
                      siteInfo={siteInfo}
                      permissions={permissions}
                      configureMotion={configureMotion}
                      setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                      setAlertState={setAlertState}
                      setDeleteSiteDialogOpen={setDeleteSiteDialogOpen}
                      navigate={navigate}
                    />
                  </div>
                </div>
              </div>
            </ErrorBoundary>
            <ErrorBoundary>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[87px] left-[150px] right-[1px] h-[60px] min-w-[1440px] bg-white"
                    : "absolute top-[87px] left-[75px] right-[1px] h-[60px] min-w-[1440px] bg-white"
                }
              >
                <TabsComponet
                  clickedTab={clickedTab}
                  setClickedTab={setClickedTab}
                  editMode={editMode}
                  setActiveTab={setActiveTab}
                  setPatchObject={setPatchObject}
                  setSiteInfo={setSiteInfo}
                  vmsVariables={vmsVariables}
                  setVmsVariables={setVmsVariables}
                  siteSchedules={siteSchedules}
                  siteInfo={siteInfo}
                  setSiteSchedules={setSiteSchedules}
                  setSchedulesTabActive={setSchedulesTabActive}
                  setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                  setAlertState={setAlertState}
                  setSyncNeeded={setSyncNeeded}
                  setSiteInfoChangesMade={setSiteInfoChangesMade}
                  setScheduleChangesMade={setScheduleChangesMade}
                  setDeleteScheduleDialogOpen={setDeleteScheduleDialogOpen}
                  recordingServerData={recordingServerData}
                  recordingServerPatchObject={recordingServerPatchObject}
                  setRecordingServerPatchObject={setRecordingServerPatchObject}
                  setRecordingServerChangesMade={setRecordingServerChangesMade}
                  recordingServerVisible={recordingServerVisible}
                  healthCheckData={healthCheckData}
                  setCameraHealthPatchObject={setCameraHealthPatchObject}
                  setCameraHealthChangesMade={setCameraHealthChangesMade}
                  setAddCameraHealthDialogOpen={setAddCameraHealthDialogOpen}
                  setTurnOffHealthDialogOpen={setTurnOffHealthDialogOpen}
                  webhooksInfo={webhooksInfo}
                  setWebhooksPatchObject={setWebhooksPatchObject}
                  setWebhooksChangesMade={setWebhooksChangesMade}
                  setEditMode={setEditMode}
                  showWireguardTab={showWireguardTab}
                  wireguardTunnels={wireguardTunnels}
                  wireguardTunnelsLoading={wireguardTunnelsLoading}
                  selectedWireguardTunnelId={selectedWireguardTunnelId}
                  setSelectedWireguardTunnelId={setSelectedWireguardTunnelId}
                  onWireGuardSessionUpdate={onWireGuardSessionUpdate}
                  setWireguardChangesMade={setWireguardChangesMade}
                  showDoubleTakeTab={showDoubleTakeTab}
                />
                <div className={"absolute top-[13px] right-[20px]"}>
                  {!editMode &&
                    (!doubleTakeTabOpen || doubleTakeEditable) &&
                    (permissions.add_cameras || permissions.edit_cameras) && (
                      <EditInformationButton
                        clickedTab={clickedTab}
                        setEditMode={setEditMode}
                        setActiveTab={setActiveTab}
                        setPatchObject={setPatchObject}
                        setSiteInfo={setSiteInfo}
                        vmsVariables={vmsVariables}
                        setVmsVariables={setVmsVariables}
                        siteSchedules={siteSchedules}
                        siteInfo={siteInfo}
                        setSiteSchedules={setSiteSchedules}
                        setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                        editMode={editMode}
                        setSchedulesTabActive={setSchedulesTabActive}
                        setClickedTab={setClickedTab}
                        setAlertState={setAlertState}
                        setSyncNeeded={setSyncNeeded}
                        setSiteInfoChangesMade={setSiteInfoChangesMade}
                        setScheduleChangesMade={setScheduleChangesMade}
                        setDeleteScheduleDialogOpen={
                          setDeleteScheduleDialogOpen
                        }
                        recordingServerData={recordingServerData}
                        recordingServerPatchObject={recordingServerPatchObject}
                        setRecordingServerPatchObject={
                          setRecordingServerPatchObject
                        }
                        setRecordingServerChangesMade={
                          setRecordingServerChangesMade
                        }
                        healthCheckData={healthCheckData}
                        setCameraHealthPatchObject={setCameraHealthPatchObject}
                        setCameraHealthChangesMade={setCameraHealthChangesMade}
                        setAddCameraHealthDialogOpen={
                          setAddCameraHealthDialogOpen
                        }
                        setTurnOffHealthDialogOpen={setTurnOffHealthDialogOpen}
                        webhooksInfo={webhooksInfo}
                        setWebhooksPatchObject={setWebhooksPatchObject}
                        setWebhooksChangesMade={setWebhooksChangesMade}
                        setSiteInfoBackup={setSiteInfoBackup}
                        setVmsVariablesBackup={setVmsVariablesBackup}
                        setSiteSchedulesBackup={setSiteSchedulesBackup}
                        setFlexScheduleOnEditButtonClick={
                          setFlexScheduleOnEditButtonClick
                        }
                        showWireguardTab={showWireguardTab}
                        wireguardTunnels={wireguardTunnels}
                        selectedWireguardTunnelId={selectedWireguardTunnelId}
                        setSelectedWireguardTunnelId={
                          setSelectedWireguardTunnelId
                        }
                        onWireGuardSessionUpdate={onWireGuardSessionUpdate}
                        setWireguardChangesMade={setWireguardChangesMade}
                      />
                    )}
                </div>
                <div
                  className={
                    width > 1300
                      ? "absolute top-[12px] right-[200px]"
                      : "absolute top-[12px] left-[747px]"
                  }
                >
                  {" "}
                  {schedulesTabActive &&
                    !editMode &&
                    siteInfo.integration_type_name !== "ailink" &&
                    siteInfo.integration_type_name !== "autopatrol" && (
                      <OrangeTextButton
                        onClick={() => {
                          navigate("/calendars");
                        }}
                        disabled={false}
                        text={
                          <>
                            <CalendarMonthIcon fontSize="small" />
                            &nbsp;View Calendars
                          </>
                        }
                      />
                    )}
                </div>

                <div
                  className={
                    width > 1300
                      ? "absolute top-[12px] right-[200px]"
                      : "absolute top-[12px] left-[747px]"
                  }
                >
                  {/* {schedulesTabActive && !editMode && (
                  <AddAnotherScheduleButton navigate={navigate} />
                )} */}
                </div>
                <div
                  className={
                    width > 1300
                      ? "absolute top-[12px] right-[20px]"
                      : "absolute top-[12px] left-[1008px]"
                  }
                >
                  {editMode && doubleTakeTabOpen && (
                    <OrangeTextButton
                      onClick={handleSaveDoubleTake}
                      text="SAVE CHANGES"
                      disabled={false}
                    />
                  )}
                  {editMode && !doubleTakeTabOpen && (
                    <SaveChangesButton
                      patchObject={patchObject}
                      setEditMode={setEditMode}
                      setSiteInfo={setSiteInfo}
                      setPatchObject={setPatchObject}
                      siteInfo={siteInfo}
                      clickedTab={clickedTab}
                      setActiveTab={setActiveTab}
                      vmsVariables={vmsVariables}
                      allSiteSchedules={allSiteSchedules}
                      siteSchedules={siteSchedules}
                      setAllSiteSchedules={setAllSiteSchedules}
                      setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                      setAlertState={setAlertState}
                      setSyncNeeded={setSyncNeeded}
                      editMode={editMode}
                      setSchedulesTabActive={setSchedulesTabActive}
                      setClickedTab={setClickedTab}
                      siteInfoChangesMade={siteInfoChangesMade}
                      setSiteInfoChangesMade={setSiteInfoChangesMade}
                      scheduleChangesMade={scheduleChangesMade}
                      setScheduleChangesMade={setScheduleChangesMade}
                      setDeleteScheduleDialogOpen={setDeleteScheduleDialogOpen}
                      setSiteSchedules={setSiteSchedules}
                      setArmButtonDisabled={setArmButtonDisabled}
                      recordingServerChangesMade={recordingServerChangesMade}
                      recordingServerData={recordingServerData}
                      recordingServerPatchObject={recordingServerPatchObject}
                      setRecordingServerData={setRecordingServerData}
                      setRecordingServerPatchObject={
                        setRecordingServerPatchObject
                      }
                      setRecordingServerChangesMade={
                        setRecordingServerChangesMade
                      }
                      cameraHealthChangesMade={cameraHealthChangesMade}
                      healthCheckData={healthCheckData}
                      setHealthCheckData={setHealthCheckData}
                      cameraHealthPatchObject={cameraHealthPatchObject}
                      setCameraHealthPatchObject={setCameraHealthPatchObject}
                      setCameraHealthChangesMade={setCameraHealthChangesMade}
                      setArmedStatus={setArmedStatus}
                      webhooksChangesMade={webhooksChangesMade}
                      webhooksInfo={webhooksInfo}
                      setWebhooksInfo={setWebhooksInfo}
                      webhooksPatchObject={webhooksPatchObject}
                      setWebhooksPatchObject={setWebhooksPatchObject}
                      setWebhooksChangesMade={setWebhooksChangesMade}
                      setDeactivateSiteInsteadDialogOpen={
                        setDeactivateSiteInsteadDialogOpen
                      }
                      setActivateSiteWithScheduleDialogOpen={
                        setActivateSiteWithScheduleDialogOpen
                      }
                      wireguardChangesMade={wireguardChangesMade}
                      wireGuardEditSessionRef={wireGuardEditSessionRef}
                      setWireguardTunnels={setWireguardTunnels}
                      setWireguardChangesMade={setWireguardChangesMade}
                      wireguardTunnels={wireguardTunnels}
                      wireguardTunnelsLoading={wireguardTunnelsLoading}
                      selectedWireguardTunnelId={selectedWireguardTunnelId}
                      setSelectedWireguardTunnelId={
                        setSelectedWireguardTunnelId
                      }
                    />
                  )}
                </div>
                <div
                  className={
                    width > 1300
                      ? "absolute top-[12px] right-[200px]"
                      : "absolute top-[12px] left-[878px]"
                  }
                >
                  {editMode && (
                    <CancelButton
                      setEditMode={setEditMode}
                      clickedTab={clickedTab}
                      setActiveTab={setActiveTab}
                      siteInfo={siteInfo}
                      setRecordingServerPatchObject={
                        setRecordingServerPatchObject
                      }
                      healthCheckData={healthCheckData}
                      webhooksInfo={webhooksInfo}
                      siteInfoBackup={siteInfoBackup}
                      setSiteInfo={setSiteInfo}
                      vmsVariablesBackup={vmsVariablesBackup}
                      setVmsVariables={setVmsVariables}
                      wireguardTunnels={wireguardTunnels}
                      wireguardTunnelsLoading={wireguardTunnelsLoading}
                      selectedWireguardTunnelId={selectedWireguardTunnelId}
                      setSelectedWireguardTunnelId={
                        setSelectedWireguardTunnelId
                      }
                      clearWireGuardEditSession={clearWireGuardEditSession}
                      setWireguardChangesMade={setWireguardChangesMade}
                    />
                  )}
                </div>
              </div>
            </ErrorBoundary>
            <ErrorBoundary>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[148px] left-[150px] right-[1px] h-[17vh] min-w-[1440px]"
                    : "absolute top-[148px] left-[75px] right-[1px] h-[17vh] min-w-[1440px]"
                }
              >
                {doubleTakeTabOpen ? (
                  <DoubleTakeTab
                    key={siteIdFromUrl}
                    siteId={siteIdFromUrl}
                    siteInfo={siteInfo}
                    isStaff={isStaff}
                    editMode={editMode}
                    saveRef={doubleTakeSaveRef}
                    onSiteInfoSaved={(fields) => {
                      setKeepDoubleTakeTab(true);
                      setSiteInfo((previous: any) => ({
                        ...previous,
                        ...fields,
                      }));
                    }}
                  />
                ) : clickedTab === "nine" && showWireguardTab ? (
                  editMode ? (
                    <WireGuardTabEditMode
                      wireguardTunnels={wireguardTunnels}
                      selectedTunnelId={selectedWireguardTunnelId}
                      onSelectTunnelId={setSelectedWireguardTunnelId}
                      onSessionUpdate={onWireGuardSessionUpdate}
                      setWireguardChangesMade={setWireguardChangesMade}
                    />
                  ) : (
                    <WireGuardTab
                      wireguardTunnels={wireguardTunnels}
                      wireguardTunnelsLoading={wireguardTunnelsLoading}
                      selectedTunnelId={selectedWireguardTunnelId}
                      onSelectTunnelId={setSelectedWireguardTunnelId}
                      siteId={siteIdFromUrl}
                      site={siteInfo}
                    />
                  )
                ) : (
                  activeTab
                )}
                {!camerasRefreshing && (
                  <div className="pt-[5px]">
                    <SiteCamerasTable
                      setAlertState={setAlertState}
                      setSyncNeeded={setSyncNeeded}
                      setDeativateInquiryDialogOpen={
                        setDeativateInquiryDialogOpen
                      }
                      siteCameras={siteCameras}
                      setSiteCameras={setSiteCameras}
                      setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                      setNoAutoAddCamerasDialogOpen={
                        setNoAutoAddCamerasDialogOpen
                      }
                      siteInfo={siteInfo}
                      setSiteInfo={setSiteInfo}
                      setSiteSchedules={setSiteSchedules}
                      setActiveTab={setActiveTab}
                      setDataLoaded={setDataLoaded}
                      setAllSiteSchedules={setAllSiteSchedules}
                      setVmsVariables={setVmsVariables}
                      setArmedStatus={setArmedStatus}
                      setAiLinkSite={setAiLinkSite}
                      setSiteDeployed={setSiteDeployed}
                      setCamerasNotDeployed={setCamerasNotDeployed}
                      setToolTipTitle={setToolTipTitle}
                      setConfigureMotion={setConfigureMotion}
                      setPatchObject={setPatchObject}
                      setArmButtonDisabled={setArmButtonDisabled}
                      setRecordingServerData={setRecordingServerData}
                      setRecordingServerPatchObject={
                        setRecordingServerPatchObject
                      }
                      setRecordingServerVisible={setRecordingServerVisible}
                      setHealthCheckData={setHealthCheckData}
                      setCamerasRefreshing={setCamerasRefreshing}
                      permissions={permissions}
                      setWebhooksInfo={setWebhooksInfo}
                      setWebhooksPatchObject={setWebhooksPatchObject}
                      siteSchedules={siteSchedules}
                    />
                  </div>
                )}
              </div>
            </ErrorBoundary>
          </div>
        )}
      </div>
      <div className="justify-start">
        <NavBar
          navBarCollapsed={navBarCollapsed}
          setNavBarCollapsed={setNavBarCollapsed}
          props={{}}
        />
      </div>
    </div>
  );
};
